import { useTranslation } from 'react-i18next';

const fallbackErrors = {
  required: 'Required',
  generic: 'There was an error, please try again later.',
  applicationError: 'Application Error',
  Account_In_Use: 'Email is already in use.',
  Invalid_Password_Length: 'Minimum password length is 8 characters and maximum is 20 characters.',
  Password_Policy_No_Match:
    'Passwords needs a lowercase, uppercase, special and number character.',
  Account_Locked: 'Account is locked.',
  Username_Or_Password_Incorrect: 'Email address or password incorrect.',
  EmailAddress_In_Use: 'E-mail address is already in use.',
  Password_No_Match: 'Passwords do not match.',
  Password_Reset_Token_Invalid: 'Your reset password link is invalid.',
  Password_Reset_Token_Expired: 'Your reset password link has expired.'
};

export const useErrorMessages = () : { errors: typeof fallbackErrors } => {
  const { t, ready } = useTranslation('Errors');
  
  if (!ready) {
    console.warn('Translation not ready, using fallback error messages');
    return { errors: fallbackErrors};
  }

  const errors: typeof fallbackErrors = {
    required: t('SSCandidate_Errors_Required', fallbackErrors.required),
    generic: t('SSCandidate_Errors_Generic', fallbackErrors.generic),
    applicationError: t('SSCandidate_Errors_Application_Error', fallbackErrors.applicationError),
    Account_In_Use: t('SSCandidate_Errors_Account_In_Use', fallbackErrors.Account_In_Use),
    Invalid_Password_Length: t('SSCandidate_Errors_Invalid_Password_Length', fallbackErrors.Invalid_Password_Length),
    Password_Policy_No_Match: t('SSCandidate_Errors_Password_Policy_No_Match', fallbackErrors.Password_Policy_No_Match),
    Account_Locked: t('SSCandidate_Errors_Account_Locked', fallbackErrors.Account_Locked),
    Username_Or_Password_Incorrect: t('SSCandidate_Errors_Username_Or_Password_Incorrect', fallbackErrors.Username_Or_Password_Incorrect),
    EmailAddress_In_Use: t('SSCandidate_Errors_Email_Address_In_Use', fallbackErrors.EmailAddress_In_Use),
    Password_No_Match: t('SSCandidate_Errors_Password_No_Match', fallbackErrors.Password_No_Match),
    Password_Reset_Token_Invalid: t('SSCandidate_Errors_Password_Reset_Token_Invalid', fallbackErrors.Password_Reset_Token_Invalid),
    Password_Reset_Token_Expired: t('SSCandidate_Errors_Password_Reset_Token_Expired', fallbackErrors.Password_Reset_Token_Expired)
  };
  
  return { errors };
};